export const REQUEST_INFO = 'concrete/REQUEST_INFO'
export const RECEIVE_INFO = 'concrete/RECEIVE_INFO'
export const ERROR_INFO = 'concrete/ERROR_INFO'



// WEBPACK FOOTER //
// ./src/components/info/action-types.js